import { useState } from 'react';
import type { ReactNode } from 'react';

interface DropdownProps {
  trigger: ReactNode;
  children: (close: () => void) => ReactNode;
  align?: 'left' | 'right';
  triggerClassName?: string;
  menuClassName?: string;
}

export default function Dropdown({
  trigger,
  children,
  align = 'right',
  triggerClassName = '',
  menuClassName = '',
}: DropdownProps) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`flex cursor-pointer items-center ${triggerClassName}`}
      >
        {trigger}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={close} />
          <div
            className={`absolute z-40 mt-2 min-w-[220px] rounded-lg border border-background-200 bg-background-50 p-1 ${
              align === 'right' ? 'right-0' : 'left-0'
            } ${menuClassName}`}
          >
            {children(close)}
          </div>
        </>
      )}
    </div>
  );
}